import React, { useContext, useEffect, useState, useMemo } from "react";
import Table from "../components/table/table";
import { UserContext } from "../contexts/UserContext";
import { GetAllClients } from "../helpers/api";
import CustomSelect from "../components/CustomSelect";
import { FlagFR, FlagITL, FlagMAR, FlagTUN } from "../assets/indexIcon";
import IconOpen from '../assets/icons/iconOpen.svg'
import IconCalendrier from '../assets/icons/iconCalendrier.svg'
import ModalFilter from "../components/modalFilter";
const ClientContainer = () => {
  const { user } = useContext(UserContext);

  const ListeKYC=[
    {id:0, value:'tous', label:'tous' },
    {id:1, value:'Validé', label:'Validé' },
    {id:2, value:'En attente', label:'En attente' },
]
const ListeAgents=[
    {id:0, value:'yoser', label:'yoser' },
    {id:1, value:'dora', label:'dora' },
]
const ListPaySend=[
    {id:0, value:'FR', label:'France', icon:FlagFR },
    {id:1, value:'ITL', label:'Italie' , icon:FlagITL},
]
const ListPayReceiv=[
    {id:0, value:'TND', label:'Tunisie', icon :FlagTUN },
    {id:1, value:'MAC', label:'Maroc', icon:FlagMAR },
]
  
  // const [tabs, setTabs] = useState([
  //   { id: 'all', label: 'Tous les Clients', filters: {} }
  // ]);

const [tabs, setTabs] = useState(() => {
  const stored = localStorage.getItem('filter');
  
  // return stored ? JSON.parse(stored) : [
  //   { id: 'all', label: 'Tous les Clients', filters: {} }
  // ];
  const data= stored
  ? JSON.parse(stored)
  : [{ id: 'all', label: 'Tous les Clients', filters: {} } ]

  return data.filter((item)=>item.role=== user.user.role || item.id==='all')
});


  const [activeTabId, setActiveTabId] = useState('all');

  const [apiResponse, setApiResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  // const [isChoix, setIsChoix]= useState('')

  const initialForm = {
  name: "",
  kyc: "",
  agent: "",
  origin: "",
  dest: "",
  doc: false
};

 const [form, setForm] = useState(initialForm);

  const openNewFilter = () => {
  setForm(initialForm);  
  setShowFilterModal(true);
};
  const [showFilterModal, setShowFilterModal] = useState(false);
    const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
    }
  
  const [startDate, setStartDate] = useState();
  
  const [endDate, setEndDate] = useState();
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
      
        const response = await GetAllClients(user?.accessToken,startDate, endDate, currentPage, pageSize);
        if (response?.success) {
          setApiResponse(response?.data || []);
          setTotalPage(response?.total);
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setIsLoading(false);
      }
    };
    const isDateEmpty = !startDate && !endDate
    const isDateComplete = !!(startDate && endDate)
    
    if (user?.accessToken && (isDateComplete || isDateEmpty)) fetchData();
  }, [user?.accessToken, pageSize, currentPage, startDate, endDate]);

  
const filteredData = useMemo(() => {
  const activeTab = tabs.find(t => t.id === activeTabId);
  const isAllTab = !activeTab || activeTab.id === 'all';

  // const hasDateFilter = startDate || endDate;

  if (isAllTab) return apiResponse;

  const f = activeTab?.filters || {};

  return apiResponse.filter(client => {
   

    const matchKyc =
      f.kyc === undefined ||
      (f.kyc === 'valid'
        ? client.status === 'confirmed'
        : client.status !== 'confirmed');

    const matchDoc =
      f.doc === undefined || client.isDocumentSent === f.doc;

    const matchDest =
      !f.dest || client.destinationDefaultCountry === f.dest;

    const matchOrigin =
      !f.origin || client.address?.country?.name === f.origin;

      const matchAgent =
      !f.origin || client.agent === f.agent;


    return matchKyc && matchDoc && matchDest && matchOrigin  && matchAgent;
  });
}, [apiResponse, activeTabId, tabs]);

  const addTab = (filterConfig) => {
    const newId = `tab-${Date.now()}`;
    const newTab = {
      id: newId,
      role:user.user.role,
      label: filterConfig.name || `Filtre ${tabs.length}`,
      filters: filterConfig
    
    };

    const stored = JSON.parse(localStorage.getItem('filter'))|| [{ id: 'all', label: 'Tous les Clients', filters: {} } ]
    const updatedData = [...stored, newTab]

    localStorage.setItem('filter', JSON.stringify(updatedData))
     setTabs(
    updatedData.filter(
      (item) =>
        item.id === "all" || item.role === user.user.role
      )
    );
    setActiveTabId(newId);
    setShowFilterModal(false);
  };

  const removeTab = (id, e) => {
    e.stopPropagation();
    if (id === 'all') return;
    const data= JSON.parse(localStorage.getItem('filter'))

    const newTabs = data.filter(t => t.id !== id);
    localStorage.setItem('filter', JSON.stringify(newTabs))

    setTabs(newTabs.filter((item)=>item.role===user.user.role || item.id==='all'));
    setActiveTabId('all');
  };

  const calculateAge = (birthDate) => {
    if (!birthDate) return "-";
    const birth = new Date(birthDate);
    const age = new Date().getFullYear() - birth.getFullYear();
    return `${age}`;
  };

   const columns = [
    {
      label: "Order",
      key: "order",
      customRenderers: (row) => <span className="font-bold">{row.order}</span>,
    },
    {
      label: "Nom du Client",
      key: "name",
      customRenderers: (row) => (
        <a 
          href={`/detailuser/${row._id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#111136] font-bold underline hover:text-blue-600"
        >
          {row.personalInfo?.firstName} {row.personalInfo?.lastName}
        </a>
      ),
    },
    {
      label: "Créé le",
      key: "createdAt",
      customRenderers: (row) => {
        const date = new Date(row.createdAt);
        return (
          <div className="text-[11px] leading-tight">
            {date.toLocaleDateString("fr-FR")} <br />
            <span className="text-gray-400">{date.toLocaleTimeString("fr-FR", { hour: '2-digit', minute: '2-digit' })}</span>
          </div>
        );
      },
    },
    {
      label: "Email",
      key: "email",
      customRenderers: (row) => <div className="text-sm">{row.email}</div>,
    },
    {
      label: "Téléphone",
      key: "phone",
      customRenderers: (row) => (
        <div className="text-sm font-medium">
          (+{row.personalInfo?.phone?.prefix}) {row.personalInfo?.phone?.number}
        </div>
      ),
    },
    {
      label: "Âge",
      key: "age",
      customRenderers: (row) => <div>{calculateAge(row.birthDate)} ans</div>,
    },
    {
      label: "Pays/Dest.",
      key: "country",
      customRenderers: (row) => (
        <div className="flex flex-col text-xs">
          <span className="font-bold text-gray-800">{row.address?.country?.name || "N/A"}</span>
          <span className="text-blue-500 italic">Vers: {row.destinationDefaultCountry}</span>
        </div>
      ),
    },
    {
      label: "Doc. Envoyé",
      key: "isDocumentSent",
      customRenderers: (row) => (
        <span className={`text-lg ${row.isDocumentSent ? "text-green-500" : "text-gray-300"}`}>
          {row.isDocumentSent ? "✅" : "❌"}
        </span>
      ),
    },
    {
      label: "Statut",
      key: "status",
      customRenderers: (row) => (
        <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase ${
          row.status === 'confirmed' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700'
        }`}>
          {row.status}
        </span>
      ),
    },
    
  ];


  return (
    <div className="min-h-screen p-4 md:p-8 font-sans">
      
      <div className="flex items-start  justify-between px-6 py-2 h-[60px]  mb-4 bg-white rounded-[10px]  ">

          <div className="flex items-cneter gap-2 overflow-x-auto no-scrollbar ">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              onClick={() => setActiveTabId(tab.id)}
              className={`flex items-center gap-3 h-[40px] px-6 py-3 rounded-[8px] hover:text-[#919AEB] cursor-pointer transition-all
                ${tab.id==='all' ? 'bg-[#F1F1FF] text-[#5754E5]' : 'text-[#AEB6FB] bg-white'}
                ${activeTabId=== tab.id && 'border border-[#5754E5] text-[#5754E5]' }
                `}
            >

              <span className="text-sm font-black uppercase tracking-tighter whitespace-nowrap">{tab.label}</span>
              {tab.id !== 'all' && (
                <button onClick={(e) => removeTab(tab.id, e)} className="hover:text-red-500 text-xs">✕</button>
              )}
            </div>
          ))}
          <img onClick={openNewFilter} src={IconOpen} alt="open-filter"/>
        
          </div>
         
          

        <div className="flex gap-2 bg-white items-center px-2 ">
         <label className="flex text-[10px]  text-[#35258B] font-semibold flex-col items-start"> 
            Début
            <div className=" flex items-center">
              <input
            type="date"
            value={startDate}
            max={endDate || formatDate(new Date())}
            onChange={(e) =>setStartDate(e.target.value)}
            className={` ${!startDate ? 'text-[#D1D1FF]' : 'text-[#5754E5]' } text-[14px]  font-bold  outline-none `}
          />
              <img src={IconCalendrier} alt="IconCalendrier"/>
            </div>
           
          </label>
          <span className="text-[#5754E5] text-[24px] ">→</span>
          <label className="flex  text-[10px] text-[#35258B] font-semibold flex-col items-start"> 
            Fin
            <div className=" flex items-center">
          <input
            type="date"
            value={endDate}
            // min={startDate}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) =>{
              const newEnd= e.target.value
              if(!startDate || newEnd >= startDate) {
              setEndDate(newEnd)
              

            }}}
            className={` ${!endDate ? 'text-[#D1D1FF]' : 'text-[#5754E5]' } text-[14px] font-bold outline-none `}
          /> <img src={IconCalendrier} alt="IconCalendrier"/>
          </div>
          </label>
        </div>

         
      </div>
      
      

      <div className="bg-white rounded-[10px]  border border-slate-100 p-6">

        
        <Table
        titleTable='Détails des portefeuilles clients'
          totalPage={totalPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          data={filteredData}
          columns={columns}
          loading={isLoading}
          excel={true}
        />
      </div>

      {showFilterModal && (
        <ModalFilter 
          ListeAgents={ListeAgents} 
          ListPaySend={ListPaySend} 
          ListPayReceiv={ListPayReceiv} 
          ListeKYC={ListeKYC}
          form={form}
          setForm={setForm}
          addTab={addTab}
          setShowFilterModal={setShowFilterModal}
        />
      )}
    </div>
  );
};

export default ClientContainer;